import { render, staticRenderFns } from "./ProjectBuildingEditConfirmationModal.vue?vue&type=template&id=3f124328&scoped=true&"
import script from "./ProjectBuildingEditConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./ProjectBuildingEditConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectBuildingEditConfirmationModal.vue?vue&type=style&index=0&id=3f124328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f124328",
  null
  
)

export default component.exports